import { DateInput } from 'admin/inputs/DateInput';
import { USER_ROLES } from 'admin/users/userUtils';
import { startOfYear } from 'date-fns';
import { SalvePerformanceData } from 'generated/graphql';
import jsonExport from 'jsonexport/dist';
import { downloadCSV, List, SelectInput, TextInput } from 'react-admin';

import { PerformanceDataDatagrid } from './PerformanceDataDatagrid';

const exporter = (rows: SalvePerformanceData[]) => {
  const data = rows.map((row: SalvePerformanceData) => ({
    email: row.email,
    id: row.id,
    id_uzivatela: row.userId,
    meno: row.name,
    pocet_klientov_s_doplnenym_produktom: row.productClientsCount,
    pocet_klientov_s_finoptio_vystupom: row.finoptioReportClientsCount,
    pocet_klientov_s_fintelligence_vystupom: row.fintelligenceReportClientsCount,
    pocet_klientov_s_pripojenym_uctom: row.accountClientsCount,
    pocet_odoslanych_pozvanok: row.sentUserInvitationsCount,
    pocet_prijatych_pozvanok: row.acceptedUserInvitationsCount,
    priezvisko: row.surname,
  }));
  jsonExport(
    data,
    {
      headers: [
        'id',
        'id_uzivatela',
        'meno',
        'priezvisko',
        'email',
        'pocet_odoslanych_pozvanok',
        'pocet_prijatych_pozvanok',
        'pocet_klientov_s_pripojenym_uctom',
        'pocet_klientov_s_finoptio_vystupom',
        'pocet_klientov_s_doplnenym_produktom',
        'pocet_klientov_s_fintelligence_vystupom',
      ],
    },
    (err, csv) => {
      downloadCSV(csv, 'performance');
    },
  );
};

const roles = USER_ROLES.filter((role) => ['ROLE_SCOUT', 'ROLE_FINANCIAL_ADVISOR'].indexOf(role.id) >= 0);

const filters = [
  <DateInput alwaysOn={true} label="Od" required={true} source="startDate" />,
  <DateInput alwaysOn={true} label="Do" required={true} source="endDate" />,
  <SelectInput alwaysOn={true} choices={roles} label="Rola" required={true} source="role" />,
  <TextInput alwaysOn={false} label="E-mail" source="email" />,
  <TextInput alwaysOn={false} label="Priezvisko" source="surname" />,
];

export const PerformanceDataList: React.FC = () => {
  const defaultValues = {
    endDate: new Date(),
    startDate: startOfYear(new Date()),
  };
  return (
    <List exporter={exporter} filterDefaultValues={defaultValues} filters={filters}>
      <PerformanceDataDatagrid />
    </List>
  );
};
